import { useTranslator } from 'tradera/lang/translate';
import React from 'react';
import { Button } from 'tradera/components/atoms/button/button';

const mutualFeedbackRemovalStatus = {
    available: 'Available',
    unavailable: 'Unavailable',
    requested: 'Requested',
    received: 'Received',
    denied: 'Denied'
};

export const MutualFeedbackRemoval = ({ mutualFeedbackRemovalItem }) => {
    const { t } = useTranslator();
    switch (mutualFeedbackRemovalItem.status) {
        case mutualFeedbackRemovalStatus.available:
            return (
                <Button
                    theme="action"
                    variant="outline"
                    href={mutualFeedbackRemovalItem.transactionIdUrl}
                    className="extra-small-action">
                    {mutualFeedbackRemovalItem.statusText}
                </Button>
            );
        case mutualFeedbackRemovalStatus.received:
            return (
                <>
                    <div>
                        <label className="mutual-feedback-removal-accept-message">
                            <span className="icon warning--before" />
                            <span>{mutualFeedbackRemovalItem.statusText}</span>
                        </label>
                    </div>
                    <div>
                        <a
                            href={
                                mutualFeedbackRemovalItem.feedbackRemovalRequestIdUrl
                            }
                            className="mutual-feedback-removal-accept-flow extra-small-action btn btn-primary">
                            {t('mutualFeedBackRemoval_to')}
                        </a>
                    </div>
                </>
            );
        case mutualFeedbackRemovalStatus.requested:
        case mutualFeedbackRemovalStatus.denied:
            return (
                <label className="extra-small-action">
                    <span className="icon warning--before" />
                    <span>{mutualFeedbackRemovalItem.statusText}</span>
                </label>
            );
        case mutualFeedbackRemovalStatus.unavailable:
            return null;
        default:
            throw new Error(
                `Unresolved mutualFeedbackRemovalItemStatus: ${mutualFeedbackRemovalItem.status}`
            );
    }
};
